<template>
    <div
        v-if="message"
        class="form-error"
    >
        {{ message }}
    </div>
</template>

<script setup lang="ts">
defineProps<{ message: string }>()
</script>

<style lang="scss" scoped>
.form-error {
    width: 100%;
    padding: 1rem;
    color: $red;
    font-family: $effra-font-stack;
    font-size: 1rem;
    line-height: 1.2em;
    font-weight: 400;
    letter-spacing: 0.025em;
    text-align: center;
}
</style>
